import React, { Component } from 'react';
import PT from 'prop-types';
import { find, includes, map } from 'lodash';
import { ReactFormField } from 'react-form-js';

var tr = require('ts-translate-js').default.boundTR;

export class EmailInputView extends Component {
    render() {
        return (
            <div className="input-group">
                <span className="input-group-addon">@</span>
                <input className="form-control" autoComplete="off" name={this.props.name} type="text" value={this.props.value} onChange={this.props.onChange}/>
            </div>
        );
    }
}

export class DateCombosView extends Component {
    render() {
        return (
            <div className="dateCombo input-group col-xs-12">
                <ul className="list-inline">
                    { this.props.showYear ? (
                          <li>
                              <select className="form-control" value={this.props.selectedYear} onChange={this.props.onYearChange}>
                                  {this.props.yearsOptions}
                              </select>
                          </li>)  : null }
                    
                    <li>
                        <select className="form-control" value={this.props.selectedMonth} onChange={this.props.onMonthChange}>
                            {this.props.monthsOptions}
                        </select>
                    </li>
                    <li>
                        <select className="form-control" value={this.props.selectedDay} onChange={this.props.onDayChange}>
                            {this.props.daysOptions}
                        </select>
                    </li>
                    <li>
                        { this.props.age ? (<span className="age">{this.props.age} {tr("ans")}</span>) : undefined }
                    </li>
                </ul>
            </div>
        );
    }
}

export class RadioButtonView extends Component {
    render() {
        return (
            <label key={this.props.key} className="radio-inline">
                <input 
                    name={this.props.name}
                    type="radio"
                    autoComplete="nope"
                    checked={this.props.checked} 
                    value={this.props.value}
                    onChange={this.props.onChange} />{this.props.label}
            </label>
        );
    }
}

export class DropdownView extends Component {
    render() {
        var itemsCtl = map(this.props.possibleValues, (val) => {
            return <option key={val.value} value={val.value}>{val.label}</option>
        });

        var selector = <div>
            <select value={this.props.value} onChange={this.props.onChange}>{itemsCtl}</select>
        </div>

        return (
        <div>
            {selector}
        </div>
        );
    }
}

export class SimpleTextFieldView extends Component {
    render() {
        return (
            <input className="form-control" autoComplete="nope" name={this.props.name} type={this.props.type} min={this.props.min} max={this.props.max} step={this.props.step} value={this.props.value} onChange={this.props.onChange}/>
        );
    }
}
SimpleTextFieldView.propTypes = {
    name: PT.string,
    value: PT.string,
    onChange: PT.func,
    type: PT.string,
    min: PT.number,
    max: PT.number,
    step: PT.number
};


export class MultipleItemsView extends Component {
    
    render() {
        const btnAlign = {
            display: 'flex',
            justifyContent: this.props.hideMode ? 'space-between' : 'flex-end'
        };

        const items = map(this.props.value, (item, i) => {
            return <li key={i}>
                <span>{item}</span><button type="button" className="btn btn-link" onClick={() => this.props.onEdit(i)}>Modifier</button><button type="button" className="btn btn-link" onClick={() => this.props.onDelete(i)}>Supprimer</button>
            </li>;
        });
        return (
            <React.Fragment> 
                <div>{items}</div> 
                {!this.props.hideMode &&                                                          
                 <div className="form-group">
                     <input className="form-control" name={this.props.field.name} type={this.props.field.type === "NUMBER" ? "number" : "text"} min={this.props.field.min} max={this.props.field.max} value={this.props.fieldValue} onChange={this.props.onInputChange}/>                                          
                 </div>    
                
                }                
                <div style={btnAlign}>
                    <button type="button" className={this.props.hideMode? "btn btn-primary" : "btn btn-default"} onClick={this.props.actionOnCancel}>{this.props.hideModeButtonText}</button>
                    {!this.props.hideMode && <button type="button" onClick={this.props.actionOnSubmit} className="btn btn-primary">{this.props.editModeButtonText}</button>}            
                </div>                          
            </React.Fragment>
        );
    }
}

MultipleItemsView.propTypes = {
    field: PT.object,
    fieldValue: PT.string,
    onInputChange: PT.func,
    onEdit: PT.func,
    onDelete: PT.func,
    value: PT.any,
    editModeButtonText: PT.string,
    actionOnSubmit: PT.func,
    hideMode: PT.bool,
    handleHideMode: PT.func,
    hideModeButtonText: PT.string,
    editMode: PT.bool,
    actionOnCancel: PT.func
};

export class MultipleDocumentsView extends Component {
    render() {
        const btnAlignSpaceBetween = {
            display: 'flex',
            justifyContent: this.props.hideMode ? 'space-between' : 'flex-end'
        };
        
        const items = map(this.props.value, (item, i) => {
            return  <li key={i}>                                       
                {map(Object.entries(item), ([key, value]) => {
                    const label = find(this.props.fields, ['name', key]).label;
                    if (includes(this.props.previewFields, key)) {
                        return <span key={key}>{`${label}: ${value} `}</span>;
                    } 
                    return null;                    
                })}
                <button type="button" className="btn btn-link" onClick={() => this.props.onEdit(i)}>Modifier</button>
                <button type="button" className="btn btn-link" onClick={() => this.props.onDelete(i)}>Supprimer</button>
            </li>;
        });

        return (
            <React.Fragment>
                <div>{items}</div>
                <div style={btnAlignSpaceBetween}>
                    <button type="button" className={this.props.hideMode? "btn btn-primary" : "btn btn-default"} onClick={this.props.actionOnCancel}>{this.props.hideModeButtonText}</button> 
                    {!this.props.hideMode && <button type="button" className="btn btn-primary" onClick={this.props.actionOnSubmit} >{this.props.editModeButtonText}</button>}         
                </div>               
            </React.Fragment>
        );
    }
}
MultipleDocumentsView.propTypes = {
    onDelete: PT.func,
    onEdit: PT.func,
    value: PT.any,
    editModeButtonText: PT.string,
    actionOnSubmit: PT.func,
    hideMode: PT.bool,
    handleHideMode: PT.func,
    hideModeButtonText: PT.string,
    editMode: PT.bool,
    handleExitEditMode: PT.func,
    actionOnCancel: PT.func,
    previewFields: PT.array,
    fields: PT.array
};

export class MultilineView extends Component {
    render() {
        return (
            <div className="form-group">
                <textarea className="form-control" rows={2} name={this.props.name} value={this.props.value} onChange={this.props.onChange} required={this.props.isRequired}></textarea>                
            </div>                
        );
    }
}
MultilineView.propTypes = {
    name: PT.string,
    value: PT.string,
    onChange: PT.func,
    isRequired: PT.bool
};

export class CheckboxView extends Component {
    render() {
        return (                      
            <label htmlFor={this.props.name} className="checkbox-inline">
                <input 
                    type="checkbox" 
                    checked={this.props.value} 
                    name={this.props.name}
                    id={this.props.name} 
                    onChange={this.props.onChange}/>
                {this.props.label}
            </label>
        );
    }
}
CheckboxView.propTypes = {
    name: PT.string,
    value: PT.any,
    onChange: PT.func,
    isRequired: PT.bool,
    label: PT.string,
    hasMoreThanThreeValues: PT.bool
};
CheckboxView.defaultProps = {
    value: false
}

export class CheckboxWithTextInputView extends Component {
    constructor(props) {
        super(props);
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    
    handleInputChange(subFieldName, newVal) {
        if (this.props.onTextInputChange)
            this.props.onTextInputChange(subFieldName, newVal);
    }

    render() {
        return <>
            <CheckboxView
                id={this.props.name} name={this.props.name}
                value={this.props.value}
                label={this.props.label}
                onChange={this.props.onChange}
            />
            { this.props.value === true
                ? <ReactFormField 
                    name={this.props.subField.name}
                    field={this.props.subField} 
                    validationErrors={this.props.subField.validationErrors} 
                    validator={this.props.validator}
                    value={this.props.subField.value} 
                    showValidationErrors={this.props.subField.showValidationErrors}
                    viewProvider={this.props.viewProvider}
                    lang={this.props.lang}
                    onChange={this.handleInputChange} 
                />
                : null
            } 
        </>;
    }
}

CheckboxWithTextInputView.propTypes = {
    name: PT.string,
    value: PT.any,
    onChange: PT.func,
    isRequired: PT.bool,
    label: PT.oneOfType([PT.string, PT.shape({ fr: PT.string, en: PT.string })]),
    hasMoreThanThreeValues: PT.bool,
    onTextInputChange: PT.func,
    textInputName: PT.string,
    textInputValue: PT.string, // for now, we block it to STRING only
    textInputRequired: PT.bool,
    viewProvider: PT.any,
    subField: PT.shape({
        name: PT.string,
        value: PT.string,
        isRequired: PT.bool,
        validationErrors: PT.array,
        showValidationErrors: PT.bool
    }),
    validator: PT.func,
    lang: PT.string
};
